import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLazyQuery } from "@apollo/client";
import { toast } from "react-toastify";
import CustomLinkButtonWithIcon from "../../../components/link-button-with-icon/link-button-with-icon.component";
import DataTable from "../../../components/data-table/data-table.component";
import StatusBadge from "../../../components/status-badge/status-badge.component";
import { FETCH_REWARD_WHEELS } from "../../../services/graphql/admin/rewardWheel";
import { formatDateRange } from "./rewardWheel.constants";
import {
  netural400,
  neturalBlack,
  primaryOrange,
} from "../../../constants/color";

const PAGE_SIZE = 10;

const RewardWheelListPage = () => {
  const [wheels, setWheels] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);

  const [fetchRewardWheels] = useLazyQuery(FETCH_REWARD_WHEELS, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      if (data && data.fetchRewardWheels) {
        const { totalCount: count, wheels: wheelsList } = data.fetchRewardWheels;
        setTotalCount(count);
        setWheels(wheelsList || []);
      } else {
        setWheels([]);
        setTotalCount(0);
      }
      setIsLoading(false);
    },
    onError: (error) => {
      setIsLoading(false);
      toast.error(error.message, {
        position: "top-center",
        autoClose: 3000,
        theme: "colored",
      });
    },
  });

  // Transform wheels data for display
  const displayGames = wheels.map((wheel, index) => ({
    ...wheel,
    number: (page - 1) * PAGE_SIZE + index + 1,
    timeDuration: formatDateRange(wheel.startDate, wheel.endDate),
    id: wheel._id,
  }));

  const getRewardWheels = async () => {
    await fetchRewardWheels({
      variables: {
        filters: {
          page,
          pageSize: PAGE_SIZE,
        },
      },
    });
  };

  useEffect(() => {
    getRewardWheels();
  }, [page]);

  const totalPages = Math.ceil(totalCount / PAGE_SIZE);

  const columns = [
    { label: "#", key: "number", flex: 1 },
    {
      label: "Status",
      key: "status",
      flex: 2,
      render: (value) => <StatusBadge status={value} />,
    },
    { label: "Time Duration", key: "timeDuration", flex: 3 },
    { label: "City", key: "city", flex: 2 },
    {
      label: "Action",
      key: "id",
      flex: 1,
      render: (value) => (
        <Link
          to={`${value}`}
          style={{
            color: primaryOrange,
            fontSize: "16px",
            textDecoration: "none",
          }}
        >
          view
        </Link>
      ),
    },
  ];

  return (
    <div className="main-div-right-section">
      <div className="second-section-style">
        {/* Header */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              marginBottom: "24px",
              display: "flex",
              flexDirection: "column",
              width: "80%"
            }}
          >
            <label
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                color: neturalBlack,
              }}
            >
              Reward wheel
            </label>
            <label
              style={{
                fontSize: "16px",
                color: netural400,
                width: "57%",
              }}
            >
              Reward customers after checkout with a quick game. Winners receive
              either a discounted product or a free product that must be
              redeemed at checkout.
            </label>
          </div>
          <div>
            <CustomLinkButtonWithIcon
              title={"Set up game"}
              linkToNavigate={"create"}
            />
          </div>
        </div>

        {/* Games list */}
        <DataTable
          title="Games"
          columns={columns}
          data={displayGames}
          totalCount={totalCount}
          page={page}
          pageSize={PAGE_SIZE}
          onPageChange={setPage}
          totalPages={totalPages}
          emptyTitle="No games generated yet"
          emptySubtitle="Start now by submitting a product slice to the Reward Wheel so customers can unlock rewards after a successful purchase from your business."
        />
      </div>
    </div>
  );
};

export default RewardWheelListPage;
